export enum PortfolioPerformanceTabs {
  Cold = 'Need attention',
  Hot = 'High momentum',
}
